"use client";

type CalLoader = ((...arguments_: unknown[]) => void) & {
  ns: Record<string, CalLoader>;
  q: unknown[][];
};

const CAL_EMBED_SRC = "https://app.cal.com/embed/embed.js";
const CAL_ORIGIN = "https://app.cal.com";
const CAL_LINK = "bntvllnt/25-min-talk";

const COPY = {
  en: {
    book: "Book a 25-minute call",
    bookHint: "Choose a time. Booking subject to confirmation.",
    malt: "Find me on Malt",
    maltHint: "My freelance profile, skills and experience.",
  },
  fr: {
    book: "Réserver un appel de 25 minutes",
    bookHint: "Choisissez un créneau. Rendez-vous soumis à confirmation.",
    malt: "Retrouvez-moi sur Malt",
    maltHint: "Mon profil freelance, mes compétences et mes expériences.",
  },
} as const;

function getCal(): CalLoader {
  const host = window as Window & { Cal?: CalLoader };
  if (host.Cal) {
    return host.Cal;
  }
  const queue: unknown[][] = [];
  const cal = Object.assign(
    (...arguments_: unknown[]) => {
      queue.push(arguments_);
    },
    { ns: {}, q: queue },
  );
  host.Cal = cal;
  const script = document.createElement("script");
  script.src = CAL_EMBED_SRC;
  script.async = true;
  document.head.append(script);
  cal("init", { origin: CAL_ORIGIN });
  return cal;
}

function openBooking(locale: string): void {
  getCal()("modal", {
    calLink: CAL_LINK,
    config: { layout: "month_view", locale },
  });
}

const row =
  "block w-full p-3 text-left hover:bg-accent rounded-md transition-colors group focus-visible:outline-2 focus-visible:outline-offset-2";

export function HomepageContact({
  locale,
}: {
  locale: string;
}): React.JSX.Element {
  const copy = locale === "fr" ? COPY.fr : COPY.en;
  return (
    <div className="space-y-1">
      <MaltLink copy={copy} />
      <button
        aria-haspopup="dialog"
        className={row}
        onClick={() => {
          openBooking(locale);
        }}
        type="button"
      >
        <span className="flex items-center justify-between">
          <span className="font-medium mb-1 group-hover:text-primary">
            {copy.book}
          </span>
          <span aria-hidden="true">→</span>
        </span>
        <span className="block text-xs text-muted-foreground">
          {copy.bookHint}
        </span>
      </button>
    </div>
  );
}

function MaltLink({
  copy,
}: {
  copy: (typeof COPY)[keyof typeof COPY];
}): React.JSX.Element {
  return (
    <a
      className={row}
      href="https://www.malt.fr/profile/bntvllnt"
      rel="noopener noreferrer"
      target="_blank"
    >
      <span className="flex items-center justify-between">
        <span className="font-medium mb-1 group-hover:text-primary">
          {copy.malt}
        </span>
        <span aria-hidden="true">↗</span>
      </span>
      <span className="block text-xs text-muted-foreground">
        {copy.maltHint}
      </span>
    </a>
  );
}
